export default __webpack_public_path__ + "static/media/home-restaurant-img-22.e57d4e0c.jpg";